import React from 'react';
import './BecomeASellerGenieGigDifference.scss';
import { Typography } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import HandshakeIcon from '@mui/icons-material/Handshake';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShieldIcon from '@mui/icons-material/Shield';
import StarIcon from '@mui/icons-material/Star';

const BecomeASellerGenieGigDifference = () => {
  const features = [
    {
      id: 1,
      icon: LocationOnIcon,
      title: "AI-Powered Geographic Matching",
      tag: "Start earning immediately",
      description: "Our intelligent system matches you with clients within your preferred radius, expanding your reach as you gain experience. Start getting orders quickly, no waiting for months."
    },
    {
      id: 2,
      icon: HandshakeIcon,
      title: "Talk First, Price Later",
      tag: "No minimum order amount",
      description: "No fixed pricing constraints. Discuss requirements, understand the project scope, then offer your best price. Build relationships and value-based pricing that reflects your true worth."
    },
    {
      id: 3,
      icon: AccountBalanceWalletIcon,
      title: "Nominal Commission Charges",
      tag: "More money in your pocket",
      description: "Keep more of what you earn with our fair and transparent fee structure. We believe in supporting your growth, not profiting excessively from your hard work."
    },
    {
      id: 4,
      icon: DashboardIcon,
      title: "AI-Powered Dashboard & Workspace",
      tag: "Professional project management",
      description: "Manage multiple projects seamlessly with our advanced workspace management system. Stay organized, meet deadlines, and deliver exceptional results consistently."
    },
    {
      id: 5,
      icon: ShieldIcon,
      title: "Complete Transparency",
      tag: "Zero hidden fees",
      description: "No hidden charges, no foreign exchange surprises, no unexpected deductions. What you see is what you get – complete transparency from the start."
    },
    {
      id: 6,
      icon: StarIcon,
      title: "Made in India, For the World",
      tag: "Built for Indian talent",
      description: "Proudly crafted in India by our dedicated team working day and night. We understand the unique challenges Indian freelancers face and build solutions specifically for you."
    }
  ];

  return (
    <div className="become-freelancer-geniegig-difference">
      <div className="difference-container">
        {/* Header Section */}
        <div className="difference-header">
          <div className="difference-tag">
            <StarIcon className="tag-icon" />
            <Typography variant="body2" className="tag-text">
              The GenieGig Difference
            </Typography>
          </div>
          <Typography variant="h3" className="difference-title">
            Solutions Built for Real Freelancers
          </Typography>
          <Typography variant="h6" className="difference-subtitle">
            We've reimagined freelancing from the ground up. Every feature is designed to solve actual problems, not create new ones.
          </Typography>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature) => {
            const IconComponent = feature.icon;
            return (
              <div key={feature.id} className="feature-card">
                <div className="card-icon">
                  <IconComponent className="icon" />
                </div>
                <div className="card-content">
                  <Typography variant="h6" className="card-title">
                    {feature.title}
                  </Typography>
                  <div className="feature-tag">
                    <Typography variant="body2" className="tag-text">
                      {feature.tag}
                    </Typography>
                  </div>
                  <Typography variant="body2" className="card-description">
                    {feature.description}
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BecomeASellerGenieGigDifference;
